import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Appbar from "@c/layout/Appbar";
import PageLayout from "@c/layout/PageLayout";
import PageStatu from "@c/layout/PageStatu";
import Confirmalert from "@c/Confirmalert";


Vue.component("appbar", Appbar);
Vue.component("Confirmalert", Confirmalert);
Vue.component("pagelayout", PageLayout);
Vue.component("pagestatu", PageStatu);

import VcPopupPicker from "vc-popup-picker";
import VcPopupDatetimePicker from "vc-popup-datetime-picker";
Vue.use(VcPopupPicker);
Vue.use(VcPopupDatetimePicker);
//按需引入vant
// import Popup from 'vant/lib/popup';
// import 'vant/lib/popup/style';
// Vue.use(Popup);
import Checkbox from 'vant/lib/checkbox';
import 'vant/lib/checkbox/style';
Vue.use(Checkbox);
import Swipe from 'vant/lib/swipe';
import 'vant/lib/swipe/style';
Vue.use(Swipe);
import SwipeItem from 'vant/lib/swipe-item';
import 'vant/lib/swipe-item/style';
Vue.use(SwipeItem);
import NoticeBar from 'vant/lib/notice-bar';
import 'vant/lib/notice-bar/style';
Vue.use(NoticeBar);
import Sticky from 'vant/lib/sticky';
import 'vant/lib/sticky/style';
Vue.use(Sticky);
import PullRefresh from 'vant/lib/pull-refresh';
import 'vant/lib/pull-refresh/style';
Vue.use(PullRefresh);
import Switch from 'vant/lib/switch';
import 'vant/lib/switch/style';
Vue.use(Switch);
import Tab from 'vant/lib/tab';
import Tabs from 'vant/lib/tabs';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';
Vue.use(Tab);
Vue.use(Tabs);
import Loading from 'vant/lib/loading';
import 'vant/lib/loading/style';
Vue.use(Loading);
import Icon from 'vant/lib/icon';
import 'vant/lib/icon/style';
Vue.use(Icon);
import Picker from 'vant/lib/picker';
import 'vant/lib/picker/style';
Vue.use(Picker);

// import { DropdownMenu, DropdownItem } from 'vant';
//千万不能引入vant的dropdown组件
// import 'vant/lib/dropdown-item/style';
// import 'vant/lib/dropdown-menu/style';
// Vue.use(DropdownMenu);
// Vue.use(DropdownItem);
//按需引入vant---------end
//数字自增到指定值
import VueAnimateNumber from "vue-animate-number";
Vue.use(VueAnimateNumber);

//复制
import VueClipboard from "vue-clipboard2";
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);

//二维码
import VueQrcode from "@chenfengyuan/vue-qrcode";
Vue.component(VueQrcode.name, VueQrcode);

Vue.config.productionTip = false;

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper);

import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import VueScroller from "vue-scroller";
Vue.use(VueScroller);

import { VueMasonryPlugin } from 'vue-masonry';
Vue.use(VueMasonryPlugin);

//rem
import "amfe-flexible/index.js";
//tool工具
import "./assets/tools/tools.js";
//全局方法
import "./assets/tools/function.js";
//初始化css
import "./assets/common/resize.scss";
//引入公共css
import "./assets/common/common.scss";
import "./assets/common/animate.scss";
// 引入图标
import "./assets/common/iconfont/iconfont.css";

import "./plugins/vue2-toast";
import "./plugins/vue-clipboard";
import vuetify from "./plugins/vuetify";

window.$app = new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
}).$mount("#app");
